import * as React from "react";
import { Box, type SxProps, type Theme } from "@mui/material";

export function LeftRightCoverageIcon(props: {
  size?: number;
  sx?: SxProps<Theme>;
}) {
  const size = props.size ?? 18;
  return (
    <Box
      component="span"
      sx={{
        width: Math.round(size * 1.35),
        height: size,
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#1976d2",
        fontSize: Math.max(10, Math.round(size * 0.52)),
        fontWeight: 950,
        lineHeight: 1,
        letterSpacing: 0.2,
        fontFamily:
          'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        ...props.sx,
      }}
    >
      L/R
    </Box>
  );
}
